import { createRouter, createWebHashHistory } from 'vue-router'
import Index from '../views/Index.vue'
import Forget from '../views/Forget.vue'
import Home from '../views/Home.vue'
import Work from '../views/Work.vue'
import Workadd from '../views/Workadd.vue'
import Cer from '../views/Cer.vue'


const routes = [
  {
    path: '/',
    name: 'Index',
    component: Index
  },
  {
    path: '/Forget',
    name: 'Forget',
    component: Forget
  },
  {
    path: '/Home',
    name: 'Home',
    component: Home
  },
  {
    path: '/Work',
    name: 'Work',
    component: Work
  },
  {
    path: '/Workadd',
    name: 'Workadd',
    component: Workadd
  },
  {
    path: '/Cer',
    name: 'Cer',
    component: Cer
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

export default router
